import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { disableWebhookRegistrationQuery } from '../apis';

const useDisableWebhookRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: disableWebhookRegistrationQuery,
    onSuccess: () => {
      toast.success('Webhook registration disabled');
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['webhook-registration', 'detail'] });
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Failed to disable webhook registration';
      toast.error(message);
    },
  });
};

export default useDisableWebhookRegistration;
